import React, { Component } from 'react';
// CRM客户来源分布
import StatisticCrmSource from './crm/StatisticCrmSource';
// CRM客户预计人数来源统计
import StatisticCrmSourceExpected from './crm/StatisticCrmSourceExpected';
// Crm客户个数统计
import StatisticCrmCustomer from './crm/StatisticCrmCustomer';
// CRM客户预计人数趋势线
import StatisticCrmExpected from './crm/StatisticCrmExpected';
// 分店感兴趣客户数统计
import StatisticCrmLocationCustomer from './crm/StatisticCrmLocationCustomer';
// 分店感兴趣预计客户数统计
import StatisticCrmLocationExpectedCustomer from './crm/StatisticCrmLocationExpectedCustomer';
// CRM客户负责人进度分布
import StatisticCustomerLeader from './crm/StatisticCustomerLeader';
// CRM客户分店进度分布
import StatisticCustomerLocation from './crm/StatisticCustomerLocation';
// Crm 跟进统计
import StatisticFollowUp from './crm/StatisticFollowUp';
// Crm 各状态客户分布
import StatisticCustomerState from './crm/StatisticCustomerState';
// CRM分店总赢单数比较
import StatisticCrmWinLocationCountRate from './crm/StatisticCrmWinLocationCountRate';
// CRM分店赢单总预计数比较
import StatisticCrmWinLocationExpectedRate from './crm/StatisticCrmWinLocationExpectedRate';
// CRM用户赢单总数比较
import StatisticCrmWinUserCountRate from './crm/StatisticCrmWinUserCountRate';
// CRM用户赢单总预计数比较
import StatisticCrmWinUserExpectedRate from './crm/StatisticCrmWinUserExpectedRate';
// Crm 客户漏斗图
import StatisticCustomerStateHistory from './crm/StatisticCustomerStateHistory';
// 分店赢单数比较
import StatisticCrmLocationWinRateCompare from './crm/StatisticCrmLocationWinRateCompare';
// 用户赢单数比较
import StatisticCrmUserWinRateCompare from './crm/StatisticCrmUserWinRateCompare';
// 分店流失数比较
import StatisticCrmLocationLostRateCompare from './crm/StatisticCrmLocationLostRateCompare';
// 用户流失数比较
import StatisticCrmUserLostRateCompare from './crm/StatisticCrmUserLostRateCompare';
// CRM赢单数按渠道统计
import StatisticCrmWinSource from './crm/StatisticCrmWinSource';
// CRM流失数按渠道统计
import StatisticCrmFailSource from './crm/StatisticCrmFailSource';
// CRM客户流失原因分布
import StatisticCustomerFailedReason from './crm/StatisticCustomerFailedReason';

const INITIAL_VISIBLE_CHARTS = 2;
const CHART_LOAD_INTERVAL = 400;
const VIEWPORT_LOAD_MARGIN = '120px 0px';

const STATISTIC_CHARTS = [
  { title: 'CRM各状态客户分布', component: StatisticCustomerState },
  { title: 'CRM客户漏斗图', component: StatisticCustomerStateHistory },
  { title: 'CRM客户个数统计', component: StatisticCrmCustomer },
  { title: 'CRM客户预计人数趋势线', component: StatisticCrmExpected },
  { title: 'CRM分店总赢单数比较', component: StatisticCrmWinLocationCountRate },
  { title: 'CRM分店赢单总预计数比较', component: StatisticCrmWinLocationExpectedRate },
  { title: 'CRM用户赢单总数比较', component: StatisticCrmWinUserCountRate },
  { title: 'CRM用户赢单总预计数比较', component: StatisticCrmWinUserExpectedRate },
  { title: '分店赢单数比较', component: StatisticCrmLocationWinRateCompare },
  { title: '用户赢单数比较', component: StatisticCrmUserWinRateCompare },
  { title: '分店流失数比较', component: StatisticCrmLocationLostRateCompare },
  { title: '用户流失数比较', component: StatisticCrmUserLostRateCompare },
  { title: '分店感兴趣客户数统计', component: StatisticCrmLocationCustomer },
  { title: '分店感兴趣预计客户数统计', component: StatisticCrmLocationExpectedCustomer },
  { title: 'CRM客户负责人进度分布', component: StatisticCustomerLeader },
  { title: 'CRM客户分店进度分布', component: StatisticCustomerLocation },
  { title: 'CRM跟进统计', component: StatisticFollowUp },
  { title: 'CRM客户来源分布', component: StatisticCrmSource },
  { title: 'CRM客户预计人数来源统计', component: StatisticCrmSourceExpected },
  { title: 'CRM赢单数按渠道统计', component: StatisticCrmWinSource },
  { title: 'CRM流失数按渠道统计', component: StatisticCrmFailSource },
  { title: 'CRM客户流失原因分布', component: StatisticCustomerFailedReason }
];

var LazyStatisticChart = class extends React.Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.requestVisible = this.requestVisible.bind(this);
  }

  componentDidMount() {
    if (this.props.visible) {
      return;
    }

    if (!window.IntersectionObserver) {
      this.requestVisible();
      return;
    }

    this.observer = new window.IntersectionObserver(
      entries => {
        if (entries[0] && entries[0].isIntersecting) {
          this.requestVisible();
        }
      },
      {
        rootMargin: VIEWPORT_LOAD_MARGIN
      }
    );

    if (this.wrapper) {
      this.observer.observe(this.wrapper);
    }
  }

  componentDidUpdate() {
    if (this.props.visible && this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  setWrapperRef(ref) {
    this.wrapper = ref;
  }

  requestVisible() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.props.onRequestVisible(this.props.index);
  }

  render() {
    const { chart, loading } = this.props;
    const Chart = chart.component;

    return (
      <div ref={this.setWrapperRef} style={{ minHeight: 420 }}>
        {this.props.visible ? (
          <Chart />
        ) : (
          <div
            style={{
              minHeight: 180,
              marginTop: 20,
              marginBottom: 20,
              padding: '28px 32px',
              backgroundColor: '#f7f8fa',
              border: '1px solid #eceff3',
              color: '#8a94a6'
            }}>
            <div style={{ color: '#4b5563', fontSize: 16, marginBottom: 12 }}>
              {chart.title}
            </div>
            <div
              style={{
                height: 10,
                width: '48%',
                backgroundColor: '#e5e9f0',
                marginBottom: 10
              }}
            />
            <div
              style={{
                height: 10,
                width: '72%',
                backgroundColor: '#edf0f5',
                marginBottom: 10
              }}
            />
            <div
              style={{ height: 10, width: '36%', backgroundColor: '#edf0f5' }}
            />
            <div style={{ marginTop: 18, fontSize: 13 }}>
              {loading ? '图表加载中...' : '滚动到此处后加载图表'}
            </div>
          </div>
        )}
      </div>
    );
  }
};

var StatisticCrmBox = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadedChartIndexes: STATISTIC_CHARTS.slice(0, INITIAL_VISIBLE_CHARTS).map(
        (chart, index) => index
      ),
      loadingChartIndex: null
    };
    this.loadQueue = [];
    this.requestVisible = this.requestVisible.bind(this);
    this.enqueueChart = this.enqueueChart.bind(this);
    this.flushVisibleQueue = this.flushVisibleQueue.bind(this);
    this.isChartLoaded = this.isChartLoaded.bind(this);
    this.isChartQueued = this.isChartQueued.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;

    if (this.loadTimer) {
      clearTimeout(this.loadTimer);
      this.loadTimer = null;
    }
  }

  requestVisible(index) {
    if (
      this.isChartLoaded(index) ||
      this.isChartQueued(index) ||
      this.state.loadingChartIndex === index
    ) {
      return;
    }

    this.enqueueChart(index);

    if (!this.loadTimer) {
      this.flushVisibleQueue();
    }
  }

  enqueueChart(index) {
    if (this.isChartQueued(index)) {
      return;
    }

    this.loadQueue.push(index);
  }

  flushVisibleQueue() {
    if (!this.mounted) {
      return;
    }

    const nextIndex = this.loadQueue.shift();

    if (nextIndex == null) {
      this.loadTimer = null;
      return;
    }

    if (this.isChartLoaded(nextIndex)) {
      this.flushVisibleQueue();
      return;
    }

    this.setState({ loadingChartIndex: nextIndex });

    this.loadTimer = setTimeout(() => {
      if (!this.mounted) {
        return;
      }

      this.setState(
        prevState => ({
          loadedChartIndexes:
            prevState.loadedChartIndexes.indexOf(nextIndex) > -1
              ? prevState.loadedChartIndexes
              : prevState.loadedChartIndexes.concat(nextIndex),
          loadingChartIndex: null
        }),
        () => {
          this.loadTimer = null;
          this.flushVisibleQueue();
        }
      );
    }, CHART_LOAD_INTERVAL);
  }

  isChartLoaded(index) {
    return this.state.loadedChartIndexes.indexOf(index) > -1;
  }

  isChartQueued(index) {
    return this.loadQueue.indexOf(index) > -1;
  }

  render() {
    return (
      <section className="nav-section-container  f-right">
        <div
          className="nav-section-content-container"
          style={{ paddingTop: 30, paddingBottom: 30 }}>
          {STATISTIC_CHARTS.map((chart, index) =>
            <LazyStatisticChart
              key={index}
              index={index}
              chart={chart}
              visible={this.isChartLoaded(index)}
              loading={this.state.loadingChartIndex === index || this.isChartQueued(index)}
              onRequestVisible={this.requestVisible} />
          )}
        </div>
      </section>
    );
  }
};


export default StatisticCrmBox;
